import { v4 as uuidv4 } from 'uuid';
import { GoodsClassifierItemsPluginSettings } from '../pluginSettings/GoodsClassifierItemsPluginSettings';
import { GoodsClassifierItemsPluginView } from '../GoodsClassifierItemsPluginView';

export const GoodsClassifierItemsTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Товары в выбранной группе',
        view: {
            content: GoodsClassifierItemsPluginSettings
            ? <GoodsClassifierItemsPluginView gridId={uuidv4()} plugin={GoodsClassifierItemsPluginSettings} />
            : <p> Справочник не настроен</p>
            
        }
    }
}
